import React from 'react';

const Header = () => (
  <div className="bg-black px-4 py-2 flex items-center justify-center flex-shrink-0 z-10">
    <img
      src="/logo.png"
      alt="Logo"
      className="h-6 w-auto object-contain"
      onError={(e) => {
        e.target.style.display = 'none';
        e.target.parentElement.insertAdjacentText('beforeend', 'VESARO');
      }}
    />
  </div>
);

export default Header;
